module.exports = __webpack_public_path__ + "static/beds-r-us-4901d00ce2e54ee56d193980bc0a1556.webp";